module.exports = __webpack_public_path__ + "img/GH-corporate-002sp-new.51baa1a0.png";